import { render, staticRenderFns } from "./PaperStatus.vue?vue&type=template&id=d240f778"
import script from "./PaperStatus.vue?vue&type=script&lang=js"
export * from "./PaperStatus.vue?vue&type=script&lang=js"
import style0 from "./PaperStatus.vue?vue&type=style&index=0&id=d240f778&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports